import { Injectable } from '@angular/core';
import {
  Router, Resolve,
  RouterStateSnapshot,
  ActivatedRouteSnapshot
} from '@angular/router';
import { Observable } from 'rxjs';

import { AnalyticsService } from '@campfire-nx/api';

import { AuthService } from '@open-portal-app/core/services/auth.service';
import { UserDataService } from '@open-portal-app/core/services/user-data.service';


@Injectable({
  providedIn: 'root'
})
export class UpdatePolicyResolver implements Resolve<any> {

  constructor(
    private router: Router,
    private authService: AuthService,
    private userDataService: UserDataService,
    private analyticsService: AnalyticsService
  ) {}
  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any>|Promise<any>|any {
    return new Promise((resolve, reject) => {
      const uuid = route.params.uuid;

      // Check if user is logged in
      if (!this.authService.isAuthenticated()) {
        this.router.navigate(['/unauthorised']);
      };

      if (!uuid) {
        this.router.navigate(['/not-found']);
      } else {
        this.userDataService.getUserData()
          .then((response: any) => {
            if (!response || response.detail) {
              this.router.navigate(['/bad-request']);
            };

            const policies = response.policies;
            let filteredPolicy;

            // look through raptor policies first
            for (const policy of policies.raptor) {
              if (policy.uuid === uuid) {
                filteredPolicy = policy;
                break;
              };
            };

            // look through legacy policies if filteredPolicy is not set from above
            if (!filteredPolicy) {
              const policyArrays: { [key: string]: any }[] = Object.values(policies);
              for (const policyArray of policyArrays) {
                filteredPolicy = policyArray.find((policy: { [key: string]: any }) => policy.slug === uuid);

                if (filteredPolicy) {
                  break;
                }
              }
            };

            // Redirect user to unauthorised page if policy not found
            if (!filteredPolicy) {
              this.router.navigate(['/not-found']);
            } else {
              resolve(filteredPolicy);
            }
          })
          .catch(error => {
            this.analyticsService.trackEvent(
              'Update Payment Page',
              'View Policy',
              'error',
              { error: error.code }
            );
            reject(error);
          });
      }
    });
  }
}
